// extracted by mini-css-extract-plugin
export var orderDetails = "_r3-2";
export var orderImage = "_r3-1";
export var orderMeta = "_r3-3";
export var orderSummary = "_r3-0";
export var rightArrow = "_r3-4";